import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import { DimensionsApi } from "../../../api/dimensions";
import { Decarbonization } from "../../../api/decarbonization";
import { useConfirmedMutation } from "../../../context/Mutation/useConfirmedMutation";

export const dimensionsKeys = {
  all: () => ["dimensions"],
  dimensionsHierarchy: () => ["dimensionsHierarchy"],
  entityAppropriateDimensionItems: () => ["entityAppropriateDimensionItems"],
  assigneeTemplates: () => ["assigneeTemplates"],
};

export function useGetDimensions(params, config) {
  const { callApi } = useAuth();

  return useQuery([...dimensionsKeys.all(), params], () => callApi(DimensionsApi.getDimensions, params), config);
}

export function useGetDimensionsHierarchy(params, config) {
  const { callApi } = useAuth();

  return useQuery(
    [...dimensionsKeys.dimensionsHierarchy(), params],
    () => callApi(DimensionsApi.getDimensionsHierarchy, params),
    config
  );
}

export function useGetEntityAppropriateDimensionItems(config) {
  const { callApi } = useAuth();
  return useQuery(
    dimensionsKeys.entityAppropriateDimensionItems(),
    () => callApi(DimensionsApi.getEntityAppropriateDimensionItems),
    config
  );
}

export function useGetAssigneeTemplates(config) {
  const { callApi } = useAuth();

  return useQuery([...dimensionsKeys.assigneeTemplates()], () => callApi(DimensionsApi.getAssigneeTemplates), config);
}

export function useUpdateAssigneeTemplate(config) {
  const { callApi } = useAuth();
  return useConfirmedMutation((data) => callApi(DimensionsApi.updateAssigneeTemplate, data), config);
}

export function useDeleteAssigneeTemplate(config) {
  const { callApi } = useAuth();
  return useConfirmedMutation((data) => callApi(DimensionsApi.deleteAssigneeTemplate, data), config);
}
